import React from 'react';
import { Users, Store, Building2 } from 'lucide-react';

interface DistributorChannelStatCardsProps {
  totalDistributors?: number;
  activeDistributors?: number;
  inactiveDistributors?: number;
}

export const DistributorChannelStatCards: React.FC<DistributorChannelStatCardsProps> = ({
  totalDistributors = 124,
  activeDistributors = 109,
  inactiveDistributors = 15,
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-6 select-none">
      {/* Total Distributors */}
      <div className="bg-white rounded-2xl p-6 border border-[#ECECF2] shadow-sm flex items-center gap-5 hover:shadow-md transition-shadow">
        <div className="w-14 h-14 rounded-2xl bg-blue-100/70 text-blue-600 flex items-center justify-center shrink-0">
          <Users className="w-7 h-7" />
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-semibold text-slate-500">Total Distributors</span>
          <span className="text-3xl font-extrabold text-slate-800 tracking-tight mt-1">
            {totalDistributors}
          </span>
        </div>
      </div>

      {/* Active Distributors */}
      <div className="bg-white rounded-2xl p-6 border border-[#ECECF2] shadow-sm flex items-center gap-5 hover:shadow-md transition-shadow">
        <div className="w-14 h-14 rounded-2xl bg-emerald-100/70 text-emerald-600 flex items-center justify-center shrink-0">
          <Store className="w-7 h-7" />
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-semibold text-slate-500">Active Distributors</span>
          <span className="text-3xl font-extrabold text-slate-800 tracking-tight mt-1">
            {activeDistributors}
          </span>
        </div>
      </div>

      {/* Inactive Distributors */}
      <div className="bg-white rounded-2xl p-6 border border-[#ECECF2] shadow-sm flex items-center gap-5 hover:shadow-md transition-shadow">
        <div className="w-14 h-14 rounded-2xl bg-rose-100/70 text-rose-600 flex items-center justify-center shrink-0">
          <Building2 className="w-7 h-7" />
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-semibold text-slate-500">Inactive Distributors</span>
          <span className="text-3xl font-extrabold text-slate-800 tracking-tight mt-1">
            {inactiveDistributors}
          </span>
        </div>
      </div>
    </div>
  );
};
